// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1qfDb","signatureButtonsRight":"ModalSign_signatureButtonsRight__1kpKQ"};